import { useNavigate } from "react-router-dom";
import { Flex } from "antd";
import { observer } from "mobx-react-lite";
import { CustomButton } from "ui";
import { CONTRACT_STATUS_ENUM } from "interfaces";
import { useStores } from "stores";
import { routes } from "constants/routes";
import { ReactComponent as EditIcon } from "../../../images/editIcon.svg";

export const EditContractButton = observer(() => {
  const navigate = useNavigate();
  const { contractCard, user } = useStores();
  const { isSeniorOperator, isCustomer } = user.roles;

  const { status } = contractCard.card;

  const showEditButton =
    (isSeniorOperator && (status === CONTRACT_STATUS_ENUM.DRAFT || status === CONTRACT_STATUS_ENUM.ACTIVE)) ||
    (isCustomer && status === CONTRACT_STATUS_ENUM.DRAFT_DECLINED);

  return (
    <Flex justify="end">
      {showEditButton && (
        <CustomButton
          type="default"
          tooltip={"Редактировать договор"}
          onClick={() => {
            navigate(`/${routes.contracts}/edit/${contractCard.card.id}`);
          }}
          icon={<EditIcon />}
        >
          Редактировать
        </CustomButton>
      )}
    </Flex>
  );
});
